import {Component, OnDestroy} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs/internal/Subscription";
import {Client} from "src/app/services/API/client";
import {LocalStorage} from "src/app/services/local-storage";
import {ModalPaymentService} from "src/app/services/ux/modal-payment.service";
import {toastrService} from "src/app/services/ux/toastr.service";
import {WalletService} from "src/app/services/wallet.service";
import {Oshee} from "src/app/models/SearchService/oshee.model";
import {OsheeHttpClientService} from "src/app/data/oshee-http-client.service";
import {finalize} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {TransactionStatusEmitter} from "src/app/models/Payment/Emitters/transaction-status-emitter";
import { TranslateService } from "@ngx-translate/core";
@Component({
    templateUrl: "oshee-search.component.html"
})
export class OsheeSearchComponent implements OnDestroy {
    //#region Subscriptions
    subscription: Subscription;
    ccSubscription: Subscription;
    finishTransactionSubscription: Subscription;
    //#endregion

    //#region Cities
    readonly cities = [
        {label: "Berat", value: "Berat"},
        {label: "Burrel", value: "Burrel"},
        {label: "Durres", value: "Durres"},
        {label: "Elbasan", value: "Elbasan"},
        {label: "Fier", value: "Fier"},
        {label: "Gjirokaster", value: "Gjirokaster"},
        {label: "Kavaje", value: "Kavaje"},
        {label: "Korce", value: "Korce"},
        {label: "Kukes", value: "Kukes"},
        {label: "Lezhe", value: "Lezhe"},
        {label: "Lushnje", value: "Lushnje"},
        {label: "Pogradec", value: "Pogradec"},
        {label: "Saranda", value: "Saranda"},
        {label: "Shijak", value: "Shijak"},
        {label: "Shkoder", value: "Shkoder"},
        {label: "Shkoder Fshat", value: "ShkoderFshat"},
        {label: "Tirana 1", value: "Tirana1"},
        {label: "Tirana 2", value: "Tirana2"},
        {label: "Tirana 3", value: "Tirana3"},
        {label: "Vlore", value: "Vlore"}
    ];
    //#endregion

    searchForm: FormGroup;

    hasParam = false;

    isLoading = false;

    hasResults = false;

    private _osheeRecords: Oshee[];
    public get osheeRecords(): Oshee[] {
        return this._osheeRecords;
    }

    public set osheeRecords(value: Oshee[]) {
        this._osheeRecords = value;
        this.hasResults = !!value.length;
    }

    selectedInvoice: Oshee = {} as Oshee;
    invoiceIndex: number;

    constructor(
        private fb: FormBuilder,
        private toastr: toastrService,
        private route: ActivatedRoute,
        private modalService: ModalPaymentService,
        private walletService: WalletService,
        private ls: LocalStorage,
        private osheeDataClient: OsheeHttpClientService,
        private translateService: TranslateService
    ) {
        this.searchForm = this.fb.group({
            customerNumber: [""],
            isAktMarreveshje: [false],
            invoiceNumber: [""],
            instanceName: [undefined]
        });

        this.subscription = walletService.$walletReadyEmitter.subscribe(
            (isReady: boolean) => {
                if (isReady) {
                    this.processOsheeTransaction();
                }
            }
        );

        this.ccSubscription = walletService.$creditCardReadyEmitter.subscribe(
            (ccSelected: boolean) => {
                if (ccSelected) {
                    this.processOsheeTransaction(ccSelected);
                }
            }
        );

        this.finishTransactionSubscription = walletService.$transactionFinish.subscribe(
            (value) => {
                if (value) {
                    this.removeFinishedTransactionFromRecords();
                }
            }
        );

        this.route.params.subscribe((params: any) => {

            // * If param object is empty
            if (!Object.keys(params).length) {
                return;
            }

            this.searchForm.controls["customerNumber"]
                .setValue(params.customerNumber);

            this.searchForm.controls["isAktMarreveshje"]
                .setValue(this.stringToBool(params.isAktMarreveshje));

            this.searchForm.controls["invoiceNumber"].setValue(params.contractNumber);

            this.searchForm.controls["instanceName"].setValue(params.city);

            this.hasParam = true;
            this.onSearch();
        });
    }

    private stringToBool(str: string): boolean {
        return str.toLowerCase() === "true";
    }

    onSearch() {
        this.isLoading = true;

        this.osheeDataClient
            .Search(
                this.searchForm.value.customerNumber,
                this.searchForm.value.isAktMarreveshje,
                this.searchForm.value.invoiceNumber,
                this.searchForm.value.instanceName
            )
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (response: Oshee[]) => {
                    this.osheeRecords = response;
                },
                error: (error: HttpErrorResponse) => {

                    // * Empty Oshee records
                    this.osheeRecords = [] as Oshee[];
                    if (error.error === "invalid_parameters") {
                        this.toastr.warning(this.translateService.instant("Services.FillInContractNumber"));
                    } else if (
                        error.error ===
                        "Instance Name Mandetary for 6-Degit Customer Number Serarch"
                    ) {
                        this.toastr.warning(
                          this.translateService.instant("Services.ContractNumberMoreThanSix")
                        );
                    } else if (error.error === "oshee_search_failed") {
                        this.toastr.warning(
                          this.translateService.instant("Services.InvoiceSearchNotWork")
                        );
                    } else if (error.error.indexOf("Invalid Customer Number") === 0) {
                        this.toastr.warning(this.translateService.instant("Services.ContractNotValid"));
                    } else if (error.error === "no_invoices") {
                        this.toastr.warning(this.translateService.instant("Services.NoEntriesFound"));
                    } else {
                        this.toastr.warning(error.error);
                    }
                }
            });
    }

    onPay(index) {
        this.invoiceIndex = index;
        this.selectedInvoice = this.osheeRecords[index];

        this.walletService.selectInvoice(this.selectedInvoice);
        this.walletService.amountOfTransaction = this.selectedInvoice.totalAmt;
        this.modalService.open();
    }

    processOsheeTransaction(creditCardMethod: boolean = false) {
        const osheeInvoice = {
            invoice: this.walletService.getInvoice(),
            ServiceFields: [
                {
                    FieldName: "isAktMarreveshje",
                    FieldValue: this.searchForm.value.isAktMarreveshje ? "true" : "false"
                }
            ],
            ipAddress: "127.0.0.1",
            deviceId: "EternaWebPosta"
        };

        if (creditCardMethod) {
            this.osheeDataClient
                .PayCC(osheeInvoice)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: (response) => {
                        if (!response.data) {
                            this.walletService.emitTransactionProgress({
                                    isSuccess: false,
                                    error: response.error.message
                                }
                            );
                            return;
                        }
                        this.walletService.emitTransactionProgress(
                            {
                                isSuccess: true,
                                error: null
                            }
                        );
                        this.ls.set("sn", "oshee");

                        window.location = (response.data.redirect);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject: TransactionStatusEmitter = {
                            isSuccess: false,
                            error: error.message
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
        } else {
            this.osheeDataClient
                .PayWallet(osheeInvoice)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: () => {
                        const emmiterObject: TransactionStatusEmitter = {
                            isSuccess: true,
                            error: null
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject = {
                            isSuccess: false,
                            error: error.error.message
                        };
                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
        }
    }

    private removeFinishedTransactionFromRecords() {
        this.osheeRecords.splice(this.invoiceIndex, 1);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.ccSubscription.unsubscribe();
        this.finishTransactionSubscription.unsubscribe();
    }
}
